import type { VFC } from 'react'
import AppImage from 'shared-components/ui/AppImage'
import styles from 'shared-components/ui/AwardLabel.module.css'
import IconLabel from 'shared-components/ui/IconLabel'
import type { BasicStyledComponent, DSAwardLabel } from 'shared-definitions/types'

interface AwardLabelProps extends BasicStyledComponent {
  label: DSAwardLabel
}

const AwardLabel: VFC<AwardLabelProps> = ({ label, className }) => (
  <IconLabel
    title={label.title}
    className={className}
    iconEl={
      label.icon ? (
        <AppImage className={styles.iconContainer} image={label.icon} sizes={16} layout="raw" />
      ) : null
    }
  />
)

export default AwardLabel
